var exports = {
  "k": "xe7b6e3d6--023ec9--container",
};

module.exports = exports;
